module.exports = __webpack_public_path__ + "staticPO/img/logoa.373fe07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoa.png
// module id = NPqd
// module chunks = 1